/* eslint-disable import/no-unresolved */
import { useState } from 'react';
import { useHostSelector } from 'store';
import { MfeToolkitClaim } from '@dtna/dvs-support-dcp-shared-state/lib/constants/claims';
import { UserSelectors } from '@dtna/dvs-support-dcp-shared-state/lib/selectors/user.selector';
import useHasClaims from '@dtna/dvs-support-dcp-shared-state/lib/hooks/useHasClaims';
import { parseMfeToolkitFromCookies } from '@dtna/dvs-core-dcp-client-utils/lib/utils/mfe';

import MfeToolkitModal from './MfeToolkitModal';

function MfeToolkit() {
  const settings = parseMfeToolkitFromCookies();
  const userIsSignedIn = useHostSelector(UserSelectors.selectUserIsSignedIn);

  const [open, setOpen] = useState(false);

  const handleClick = () => {
    setOpen(!open);
  };

  const userHasClaim = useHasClaims(MfeToolkitClaim.READ, { admin: false, dtna: false, root: false });

  if (!userIsSignedIn || !userHasClaim) {
    return null;
  }

  return (
    <>
      <div
        className={`mfe-toolkit ${Object.keys(settings).length > 0 ? 'active' : ''}`}
        onClick={handleClick}
        aria-hidden="true"
      >
        MFE TOOLS
      </div>
      {open && (<MfeToolkitModal closeModalCallback={() => setOpen(false)} />)}
    </>
  );
}

export default MfeToolkit;
